export default __webpack_public_path__ + "static/media/ISKO CLASS 8 SYLLABUS.2017e7d6.pdf";